import React from "react";
import { useNavigate } from "react-router-dom";

interface CategoryCardProps {
  title: string;
  icon: React.ReactNode;
  imageUrl: string;
  categoryId: string;
}

const CategoryCard: React.FC<CategoryCardProps> = ({ title, icon, imageUrl, categoryId }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/flights/category/${categoryId}`);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className="bg-white rounded-3xl p-2 shadow-card w-full min-w-0 h-44 sm:h-48 text-left cursor-pointer transition-transform hover:scale-[1.02]"
    >
      <div className="relative rounded-2xl bg-gray-200 overflow-hidden w-full h-full">
        <img
          src={imageUrl}
          alt={title}
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 flex flex-col justify-between p-3 text-white">
          <div className="text-2xl">{icon}</div>
          <div className="text-lg font-bold tracking-tight text-shadow-glow">{title}</div>
        </div>
      </div>
    </button>
  );
};

export default CategoryCard;
